export default "__VITE_ASSET__ChKv6cfF__"